"use client";

import { useTransition } from "react";
import { useRouter } from "next/navigation";

type FilterOption = { value: string; label: string; href: string };

export function PlazaFilterSelect({ label, value, options }: {
  label: string;
  value: string;
  options: FilterOption[];
}) {
  const router = useRouter();
  const [pending, startTransition] = useTransition();

  return (
    <label className="flex min-w-0 flex-1 items-center gap-2 text-xs text-[var(--color-muted)] sm:flex-none">
      <span className="shrink-0">{label}</span>
      <select
        value={value}
        disabled={pending}
        aria-busy={pending}
        onChange={event => {
          const option = options.find(item => item.value === event.target.value);
          if (option) startTransition(() => router.push(option.href, { scroll: false }));
        }}
        className="h-11 min-w-0 w-full rounded-xl border border-[var(--color-line-strong)] bg-[var(--color-raised)] px-3 text-sm text-[var(--color-paper)] disabled:opacity-60 sm:w-40"
      >
        {options.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
      </select>
    </label>
  );
}
